import Component from './Add';

export default Component;
